"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = string => {
  return string.replace(" ", "-").replace("/", "-").toLowerCase();
};
exports.default = _default;